<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>

        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="FeeForm">
                            <div class="col-lg-12">
                                <div class="card custom-card">
                                    <div class="card-body pb-0">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <div class=" d-flex align-items-center pl-3">
                                                    <img alt="Logo" src="../../assets/images/receipt.png"
                                                        class="mh-45px pb-2">
                                                    <div class="ml-2">
                                                        <h3 class="main-content-label mb-1"><b>
                                                                Registration Fees
                                                            </b></h3>
                                                        <p class="text-muted card-sub-title mb-0">
                                                            List Of Registration Fee Templates
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <hr>
                                        <div class="row clearfix mt-2">
                                            <div class="table-responsive table-container tab mt-1">
                                                <table class="table table-bordered  text-left">
                                                    <thead>
                                                        <tr class="text-left">
                                                            <th class="f600">
                                                                Student Name
                                                            </th>
                                                            <th class="f600">
                                                                Course Name
                                                            </th>
                                                            <th class="f600">
                                                                College Name
                                                            </th>
                                                            <th class="f600 text-center" *ngIf="showAlreadyPaidColumn">
                                                                Already Paid
                                                            </th>

                                                            <!-- NEW -->
                                                            <th class="f600 text-center" *ngIf="showUploadColumn">
                                                                Upload Receipt
                                                            </th>
                                                            <th class="f600 text-center" *ngIf="showActionColumn">Action
                                                            </th>
                                                            <th width="10%" class="f600 text-center" *ngIf="showReceiptColumn()">
                                                                Receipt</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody id="table_data" formArrayName="feeApplyArray">
                                                        <tr *ngFor="let fee of getfeeApplyArrayControls(); let i = index; let last = last; let item of FeeTable "
                                                            [formGroupName]="i">
                                                            <td>
                                                                <input class="form-controls input-sm"
                                                                    formControlName="StudentName" readonly>
                                                            </td>
                                                            <td>
                                                                {{courseName}}
                                                            </td>
                                                            <td>
                                                                {{collegeName}}
                                                            </td>
                                                            <td class="text-center" *ngIf="showAlreadyPaidColumn">

                                                                <label class="ml-2">
                                                                    <input type="radio" value="YES"
                                                                        formControlName="AlreadyPaid"
                                                                        (change)="onAlreadyPaidChange(i)">
                                                                    Yes
                                                                </label>

                                                                <label class="marginleft">
                                                                    <input type="radio" value="NO"
                                                                        formControlName="AlreadyPaid"
                                                                        (change)="onAlreadyPaidChange(i)">
                                                                    No
                                                                </label>



                                                            </td>
                                                            <!-- <td class="text-center" *ngIf="PayBtn">

                                                                <div
                                                                    *ngIf="feeApplyArray.at(i).get('AlreadyPaid').value == 'YES'">

                                                                    <input type="file"
                                                                        (change)="onFileSelect($event, i)" />

                                                                    <div class="text-danger"
                                                                        *ngIf="submitted && !feeApplyArray.at(i).get('Receipt').value">
                                                                        Receipt Required
                                                                    </div>

                                                                </div>

                                                            </td> -->
                                                            <!-- Upload Receipt TD -->
                                                            <td class="text-center"
                                                                *ngIf="feeApplyArray.at(i)?.get('AlreadyPaid')?.value == 'YES'">

                                                                <input type="file" (change)="onFileSelect($event, i)" />

                                                                <div class="text-danger"
                                                                    *ngIf="submitted && !feeApplyArray.at(i)?.get('Receipt')?.value">
                                                                    Receipt Required
                                                                </div>

                                                                <button type="button" [disabled]="savebtn"
                                                                    class="btn sz btn-primary btn-icon-text floatright fr"
                                                                    (click)="saveFiles(i)">
                                                                    <span
                                                                        style="display: contents; align-items: center;">
                                                                        Save
                                                                    </span>

                                                                </button>
                                                                
                                                                <!-- <button class="btn btn-success mt-2"
                                                                    (click)="saveFiles()">
                                                                    Save Receipt
                                                                </button> -->

                                                            </td>
                                                            <!-- <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="StuStatus" readonly>
                                                               
                                                            </td> -->
                                                            <!-- <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="StuSocial" readonly>
                                                                
                                                            </td> -->

                                                            <!-- <td>
                                                                <input class="form-controls input-sm"
                                                                formControlName="StuAdm" readonly>
                                                            </td> -->
                                                             <td class="text-center"
                                                                *ngIf="feeApplyArray.at(i).get('AlreadyPaid').value != 'YES'">
                                                                <!-- Show Pay button only when payment not done -->
                                                                <button type="button" *ngIf="!item.PayStatus"
                                                                    [disabled]="ShowMsg || ApprovalCheck || showErrMsg"
                                                                    class="btn sz btn-primary btn-icon-text mt-1 fr"
                                                                    (click)="openFeeProcessPopUp(item)"> <span
                                                                        style="display: contents; align-items: center;">
                                                                        <img width="20vh"
                                                                            src="../../assets/images/pay-per-click.gif"
                                                                            style="margin-right: 5px;"> Pay </span>
                                                                </button> <!-- Show Fees Paid only after payment -->
                                                                <h3 class="main-content-label mb-1" *ngIf="item.PayStatus">
                                                                    <b [class.disabled]="updateBtn"> {{item.FeePaid}} </b>
                                                                </h3>
                                                            </td>
                                                            <!-- <td  class="text-center">
                                                                <button type="button" *ngIf="PayBtn" [disabled] = "ShowMsg || ApprovalCheck || showErrMsg"
                                                                class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                                (click)="openFeeProcessPopUp(item)">
                                                                <span style="display: contents; align-items: center;">
                                                                    <img width="20vh" src="../../assets/images/pay-per-click.gif"
                                                                        style="margin-right: 5px;">
                                                                        Pay
                                                                </span>
                                                            </button>
                                                            <h3 class="main-content-label mb-1" *ngIf="PayStatus">
                                                                <b  [class.disabled]="updateBtn" (click)="null">{{FeePaid}}</b>
                                                            </h3>
                                                            </td> -->
                                                            <td *ngIf="item.PayStatus"> <a *ngIf="item.FeePaid === 'Already Paid'"
                                                                    (click)="viewReceipt()"
                                                                    style="cursor: pointer;"> <label
                                                                        class="main-content-label mb-1">View</label> </a>
                                                                <div *ngIf="item.FeePaid !== 'Already Paid'">
                                                                    <h3 [class.disabled]="updateBtn"
                                                                        (click)="!updateBtn ? addnewrecord(item) : null"
                                                                        class="main-content-label mb-1 ">
                                                                        <!-- <span style="display: flex; align-items: center;"> -->
                                                                        <b>{{item.PaymentStatus == 'Refund' ? 'Old
                                                                            Receipt' : 'Payment Status'}}</b>
                                                                        <!-- </span> --> </h3>
                                                                </div>
                                                            </td>
                                                            <!-- <td *ngIf="PayStatus" >
                                                                <div>
                                                                    <h3 [class.disabled]="updateBtn" (click)="!updateBtn ? addnewrecord(item) : null"
                                                                        class="main-content-label mb-1 ">
                                                                        <b>{{item.PaymentStatus == 'Refund' ? 'Old
                                                                            Receipt' : 'Payment Status'}}</b>
                                                                    </h3>
                                                                </div>
                                                            </td> -->
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div *ngIf="ShowMsg">
                                                <p><b class="red">Note : {{Message}}</b></p>
                                            </div>
                                            <div *ngIf="ApprovalCheck">
                                                <p><b class="red">Note : {{Message2}}</b></p>
                                            </div>
                                            <div *ngIf="TempMsg">
                                                <p><b class="red">Note : {{Message3}}</b></p>
                                            </div>
                                            <div *ngIf="showErrMsg">
                                                <p><b class="red">Note : {{Message4}}</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>